import { render, staticRenderFns } from "./SignUpController.vue?vue&type=template&id=31cabf10&scoped=true"
import script from "./SignUpController.vue?vue&type=script&lang=js"
export * from "./SignUpController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cabf10",
  null
  
)

export default component.exports